import Abstract from '../../framework/Abstract';

import './D6.1-order-history-table.scss';

class D61OrderHistoryTable extends Abstract {
	init = () => {}
}

export default D61OrderHistoryTable;
